import { PropTypes } from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";
import { SkeletonAvatar } from "~/components/forms/SkeletonComponents";

const SIZES = {
  tiny: 20,
  small: 27,
  medium: 35,
  large: 70,
};

const Avatar = ({
  name,
  avatar,
  sizeType = "small",
  showTooltip = true,
  loadingSkeleton = false,
  extraClasses = "",
}) => {
  const size = SIZES[sizeType];

  const getInitials = (fullName) => {
    if (!fullName) {
      return "";
    }
    return fullName
      .split(" ")
      .slice(0, 2)
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const renderAvatar = () => {
    if (!avatar) {
      return (
        <div
          className={`rounded-circle text-black font-weight-bold d-flex align-items-center justify-content-center ${extraClasses}`}
          style={{
            width: size,
            height: size,
            fontSize: `calc(${size}px * 0.4)`,
            backgroundColor: "#DBDBDB",
          }}
        >
          {getInitials(name)}
        </div>
      );
    }

    return (
      <img
        src={avatar}
        alt={`${name}'s avatar`}
        className={`rounded-circle ${extraClasses}`}
        loading="lazy"
        width={size}
        height={size}
      />
    );
  };

  if (loadingSkeleton) {
    return <SkeletonAvatar data-testid="skeleton-avatar" />;
  }

  if (!avatar && !name) {
    return null;
  }

  return showTooltip ? (
    <Tooltipable text={name} placement="top">
      {renderAvatar()}
    </Tooltipable>
  ) : (
    renderAvatar()
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  avatar: PropTypes.string,
  sizeType: PropTypes.string,
  showTooltip: PropTypes.bool,
  loadingSkeleton: PropTypes.bool,
  extraClasses: PropTypes.string,
};

export default Avatar;
